module.exports = __webpack_public_path__ + "img/ic_shield_check.e16c01ce.svg";